
// import React, { useEffect } from "react";
// import { Link } from "react-router-dom";
// import { useSelector, useDispatch } from "react-redux";
// import { setCartCount } from "../../../features/cart/redux/cartSlice";
// import { getCartCount } from "../service/CartCount.service";

// const AddtoCart = () => {
//   const dispatch = useDispatch();
//   const cartCount = useSelector((state) => state.cart.cartCount);
//   const cartType =
//     localStorage.getItem("cartType") ||
//     localStorage.getItem("fresh") ||
//     "customer";

//   useEffect(() => {
//     fetchCartCount();
//   }, [cartType]);

//   const fetchCartCount = async () => {
//     try {
//       const res = await getCartCount(cartType);
//       console.log("Cart Count API:", res);
//       const count =
//         res?.count ??
//         res?.data?.count ??
//         res?.data ??
//         0;

//       dispatch(setCartCount(count));
//     } catch (error) {
//       console.error(error);
//       dispatch(setCartCount(0));
//     }
//   };

//   return (

//     <div className="box-wishlist">
//       <div className="link-Rottaion">
//         <Link to="/checkout/cart">
//           <i className="bi bi-cart-check-fill"></i>
//           <span className="badge-danger">{cartCount}</span>
//         </Link>
//       </div>
//     </div>

//   );
// };
// export default AddtoCart;


// import React, { useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { useSelector, useDispatch } from "react-redux";
// import { setCartCount } from "../../../features/cart/redux/cartSlice";
// import { getCartCount } from "../service/CartCount.service";

// const AddtoCart = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const cartCount = useSelector((state) => state.cart.cartCount);
//   const cartType =
//     localStorage.getItem("cartType") ||
//     localStorage.getItem("fresh") ||
//     "customer";

//   useEffect(() => {
//     fetchCartCount();
//   }, [cartType]);

//   const fetchCartCount = async () => {
//     try {
//       const res = await getCartCount(cartType);
//       console.log("Cart Count API:", res);
//       const count =
//         res?.count ??
//         res?.data?.count ??
//         res?.data ??
//         0;

//       dispatch(setCartCount(Number(count)));
//     } catch (error) {
//       console.error(error);
//       dispatch(setCartCount(0));
//     }
//   };

//   const handleCartClick = () => {
//     if (cartCount > 0) {
//       navigate("/checkout/cart");
//     } else {
//        navigate("/cart-empty");
//     }
//   };

//   return (
//     <div className="box-wishlist">
//       <div className="link-Rottaion">
//         <div onClick={handleCartClick} style={{ cursor:"pointer" }} style={{ color:"#FFF"}}>
//               <i className="bi bi-cart-check-fill"></i>
//           <span className="badge-danger">
//             {cartCount}
//           </span>
//         </div>

//       </div>
//     </div>
//   );
// };

// export default AddtoCart;


import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setCartCount } from "../../../features/cart/redux/cartSlice";
import { getCartCount } from "../service/CartCount.service";

const AddtoCart = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const cartCount = useSelector((state) => state.cart.cartCount);
  const cartType =
    localStorage.getItem("cartType") ||
    localStorage.getItem("fresh") ||
    "customer";

  useEffect(() => {
    fetchCartCount();
  }, [cartType]);

  const fetchCartCount = async () => {
    try {
      const res = await getCartCount(cartType);

      const count =
        Number(
          res?.count ??
          res?.data?.count ??
          res?.data ??
          0
        );

      dispatch(setCartCount(count));
    } catch (error) {
      console.error(error);
      dispatch(setCartCount(0));
    }
  };

  const handleCartClick = () => {
    // Hamesha checkout route par jao
    navigate("/checkout/cart");
  };

  return (
    <div className="box-wishlist">
      <div className="link-Rottaion">
        <div
          onClick={handleCartClick}
          style={{
            cursor: "pointer",
            color: "#FFF",
          }}
        >
          <i className="bi bi-cart-check-fill"></i>

          <span className="badge-danger">
            {cartCount}
          </span>
        </div>
      </div>
    </div>
  );
};

export default AddtoCart;